import React, {useRef, useState} from 'react';
import {useHistory} from 'react-router-dom';
import Joyride, {ACTIONS, EVENTS, STATUS} from 'react-joyride';
import {JoyRideTooltip} from 'components/JoyrideComponents';
import {useTranslation} from 'react-i18next';
import {AuthContext} from 'contexts/auth.context';
export default function ERPJoyRide({getIndexClick}): JSX.Element {
  const joyride = useRef();
  const [run, setRun] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const {t} = useTranslation();
  const history = useHistory();
  const steps = (user) => {
    return [
      {
        disableBeacon: true,
        content: (
          <div>
            <div style={{padding: '40px'}}>
              <div className="main-profile-name">
                {t('Hi')} {user.firstName},
              </div>
              <div className="main-profile-descrtn">
                Welcome to the user portal of PTW ERP. Lets go on a quick tour
                of the tool.
              </div>
            </div>
          </div>
        ),
        placement: 'center' as const,
        spotlightPadding: 10,
        target: 'body',
      },
      {
        disableBeacon: true,
        content: <p>You can use this tab to view your Profile at any point.</p>,
        placement: 'bottom' as const,
        spotlightPadding: 10,
        target: '#ess-profile',
      },
      {
        disableBeacon: true,
        content: <p>Use this tab to change the way you view data.</p>,
        placement: 'bottom' as const,
        spotlightPadding: 10,
        target: '.profile-setting-joyride',
      },
      {
        disableBeacon: true,
        content: <p>You can use this tab to manage your leaves.</p>,
        placement: 'bottom' as const,
        spotlightPadding: 10,
        target: '#ess-leaves',
      },
      {
        disableBeacon: true,
        content: (
          <p>
            This will be your go-to section when you want to check how much time
            you can be away from work.
          </p>
        ),
        placement: 'bottom' as const,
        spotlightPadding: 10,
        target: '#leaves-tab-leaveBalance',
      },
      {
        disableBeacon: true,
        content: (
          <p>
            Using this section, you&#39;ll be able to always keep an eye on what
            leaves you&#39;ve taken in the past.
          </p>
        ),
        placement: 'bottom' as const,
        spotlightPadding: 10,
        target: '.leave-history-joyride',
      },
      {
        disableBeacon: true,
        content: <p>Let&#39;s get started on your first leave application.</p>,
        placement: 'bottom' as const,
        spotlightPadding: 10,
        target: '.apply-leave-btn-joyride',
      },
      {
        disableBeacon: true,
        content: <p>You can view your leave and holiday calendar here.</p>,
        placement: 'bottom' as const,
        spotlightPadding: 10,
        target: '#leaves-tab-leaveCalendar',
      },
      {
        disableBeacon: true,
        content: <p>You can view the list of public holidays here.</p>,
        placement: 'bottom' as const,
        spotlightPadding: 10,
        target: '#ess-holidays',
      },
      {
        disableBeacon: true,
        content: (
          <p>
            You can use this tab to view a list of departments within your
            company and also a list of users within each department.
          </p>
        ),
        placement: 'bottom' as const,
        spotlightPadding: 10,
        target: '#ess-departments',
      },
      {
        disableBeacon: true,
        content: <p>You can interact with other users using groups.</p>,
        placement: 'bottom' as const,
        spotlightPadding: 10,
        target: '#ess-groups',
      },
      {
        disableBeacon: true,
        content: (
          <p>
            Each group and subgroup will have a forum section in which you can
            post messages.
          </p>
        ),
        placement: 'bottom' as const,
        spotlightPadding: 10,
        target: '.post-btn-joyride',
      },
      {
        disableBeacon: true,
        content: (
          <p>
            If you would like to create a subset of this group, you can add a
            subgroup with selected members from the group.
          </p>
        ),
        placement: 'bottom' as const,
        spotlightPadding: 10,
        target: '.add-btn-subgroup',
      },
    ];
  };

  const stepsAdmin = (user) => {
    return [
      {
        disableBeacon: true,
        content: (
          <div>
            <div style={{padding: '40px'}}>
              <div className="main-profile-name">
                {t('Hi')} {user.firstName},
              </div>
              <div className="main-profile-descrtn">
                Welcome to the admin portal of PTW ERP. Let&#39;s go on a quick
                tour of the tool.
              </div>
            </div>
          </div>
        ),
        placement: 'center' as const,
        spotlightPadding: 10,
        target: 'body',
      },
      {
        disableBeacon: true,
        content: <p>You can use this tab to view your Profile at any point.</p>,
        placement: 'bottom' as const,
        spotlightPadding: 10,
        target: '#ess-profile',
      },
      {
        disableBeacon: true,
        content: <p>Use this tab to change the way you view data.</p>,
        placement: 'bottom' as const,
        spotlightPadding: 10,
        target: '.profile-setting-joyride',
      },
      {
        disableBeacon: true,
        content: (
          <p>This is where you will be setting up your companys details.</p>
        ),
        placement: 'bottom' as const,
        spotlightPadding: 10,
        target: '#sidenav-setting-joyride',
      },
      {
        disableBeacon: true,
        content: <p>Manage all users with this module.</p>,
        placement: 'bottom' as const,
        spotlightPadding: 10,
        target: '#sidenav-um-joyride',
      },
      {
        disableBeacon: true,
        content: <p>Manage Leaves using this module.</p>,
        placement: 'bottom' as const,
        spotlightPadding: 10,
        target: '#sidenav-lm-joyride',
      },
      {
        disableBeacon: true,
        content: (
          <p>Use this module for all actions specific to you as an employee.</p>
        ),
        placement: 'bottom' as const,
        spotlightPadding: 10,
        target: '#sidenav-ess-joyride',
      },
      {
        disableBeacon: true,
        content: <p>You can use this tab to manage your leaves.</p>,
        placement: 'bottom' as const,
        spotlightPadding: 10,
        target: '#ess-leaves',
      },
      {
        disableBeacon: true,
        content: (
          <p>
            This will be your go-to section when you want to check how much time
            you can be away from work.
          </p>
        ),
        placement: 'bottom' as const,
        spotlightPadding: 10,
        target: '#leaves-tab-leaveBalance',
      },
      {
        disableBeacon: true,
        content: (
          <p>
            Using this section, you&pos;ll be able to always keep an eye on what
            leaves you&pos;ve taken in the past.
          </p>
        ),
        placement: 'bottom' as const,
        spotlightPadding: 10,
        target: '.leave-history-joyride',
      },
      {
        disableBeacon: true,
        content: <p>Let&pos;s get started on your first leave application.</p>,
        placement: 'bottom' as const,
        spotlightPadding: 10,
        target: '.apply-leave-btn-joyride',
      },
    ];
  };

  const handleJoyrideCallback = (data) => {
    const {action, index, type, status} = data;

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setRun(false);
      setStepIndex(0);
      getIndexClick('');
      localStorage.setItem('showWalkThrough', null);
    } else if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      const stepIndex = index + (action === ACTIONS.PREV ? -1 : 1);

      if (index === 0) {
        history.push('/ess/profile');
        getIndexClick('profile');
        setRun(false);
        setStepIndex(stepIndex);
        setTimeout(() => {
          setRun(true);
        }, 400);
      } else if (index === 1) {
        setRun(false);
        setStepIndex(stepIndex);
        setTimeout(() => {
          setRun(false);
        }, 400);
      } else if (index === 2) {
        history.push('/ess/leaves');
        setRun(false);
        setStepIndex(stepIndex);
        setTimeout(() => {
          setRun(true);
        }, 4000);
      } else if (index === 3) {
        setRun(false);
        setStepIndex(stepIndex);
        setTimeout(() => {
          setRun(true);
        }, 400);
      } else if (index === 4) {
        setRun(false);
        setStepIndex(stepIndex);
        setTimeout(() => {
          setRun(true);
        }, 400);
      } else if (index === 5) {
        setRun(false);
        setStepIndex(stepIndex);
        setTimeout(() => {
          setRun(true);
        }, 400);
      } else if (index === 6) {
        setRun(false);
        setStepIndex(stepIndex);
        setTimeout(() => {
          setRun(true);
        }, 400);
      } else if (index === 7) {
        history.push('/ess/holidays');
        setRun(false);
        setStepIndex(stepIndex);
        setTimeout(() => {
          setRun(true);
        }, 400);
      } else if (index === 8) {
        history.push('/ess/department');
        setRun(false);
        setStepIndex(stepIndex);
        setTimeout(() => {
          setRun(true);
        }, 400);
      } else if (index === 9) {
        history.push('/ess/groups');
        setRun(false);
        setStepIndex(stepIndex);
        setTimeout(() => {
          setRun(true);
        }, 400);
      } else if (index === 10) {
        setRun(false);
        setStepIndex(stepIndex);
        setTimeout(() => {
          setRun(true);
        }, 400);
      } else if (index === 11) {
        setRun(false);
        setStepIndex(stepIndex);
        setTimeout(() => {
          setRun(true);
        }, 400);
      }
    }
  };

  const handleJoyrideCallbackAdmin = (data) => {
    const {action, index, type, status} = data;

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setRun(false);
      setStepIndex(0);
      getIndexClick('');
      localStorage.setItem('showWalkThrough', null);
    } else if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      const stepIndex = index + (action === ACTIONS.PREV ? -1 : 1);

      if (index === 0) {
        history.push('/ess/profile');
        getIndexClick('profile');
        setRun(false);
        setStepIndex(stepIndex);
        setTimeout(() => {
          setRun(true);
        }, 400);
      } else if (index === 1) {
        setRun(false);
        setStepIndex(stepIndex);
        setTimeout(() => {
          setRun(false);
        }, 400);
      } else if (index === 2) {
        history.push('/mainSettings/company-information');
        setRun(false);
        setStepIndex(stepIndex);
        setTimeout(() => {
          setRun(true);
        }, 4000);
      } else if (index === 3) {
        history.push('/user-management/users');
        setRun(false);
        setStepIndex(stepIndex);
        setTimeout(() => {
          setRun(true);
        }, 400);
      } else if (index === 4) {
        history.push('/leave-management/leave-master');
        setRun(false);
        setStepIndex(stepIndex);
        setTimeout(() => {
          setRun(true);
        }, 400);
      } else if (index === 5) {
        history.push('/ess/leaves');
        setRun(false);
        setStepIndex(stepIndex);
        setTimeout(() => {
          setRun(true);
        }, 400);
      } else if (index === 6) {
        setRun(false);
        setStepIndex(stepIndex);
        setTimeout(() => {
          setRun(true);
        }, 400);
      } else if (index === 7) {
        setRun(false);
        setStepIndex(stepIndex);
        setTimeout(() => {
          setRun(true);
        }, 400);
      } else if (index === 8) {
        setRun(false);
        setStepIndex(stepIndex);
        setTimeout(() => {
          setRun(true);
        }, 400);
      }
    }
  };

  const showWalkThrough = localStorage.getItem('showWalkThrough') === 'true';
  return (
    <AuthContext.Consumer>
      {({userDetails, loadUserDetails}) => {
        return showWalkThrough ? (
          <Joyride
            callback={
              userDetails.isAdmin === true
                ? handleJoyrideCallbackAdmin
                : handleJoyrideCallback
            }
            ref={joyride}
            steps={
              userDetails.isAdmin === true
                ? stepsAdmin(userDetails)
                : steps(userDetails)
            }
            styles={{
              options: {
                zIndex: 1000000000,
                arrowColor: '#ff6558',
              },
            }}
            continuous={true}
            spotlightClicks={true}
            tooltipComponent={JoyRideTooltip}
            showProgress={true}
            showSkipButton={true}
          />
        ) : (
          <></>
        );
      }}
    </AuthContext.Consumer>
  );
}
